define('flight-components/Viewport',[
  'App',
  'flight/lib/component',
  'lib/vp.jquery.smartresize'
],

function(App, defineComponent){

  var uiViewport = function uiViewport() {

    var $viewport = $('body');

    this.defaultAttrs({
      colWidth: 25,
      cols: 0,
      breakpoints: {
        576: 'xs',
        960: 'sm',
        1440: 'md',
        9999: 'lg'
      }
    });


    this.update = function() {

      /** Store the width/height of the viewport */
      this.attr.width = window.innerWidth;
      this.attr.height = window.innerHeight;

      this.setViewportBreakpoint();
      this.updateElementQueryClasses();

      this.trigger(document, 'uiViewportResized', {width: this.attr.width, height: this.attr.height});
    };


    /**
     * Add a class to the body element for every multiple
     * of the total width.
     */
    this.updateElementQueryClasses = function() {
      var bodyClasses = $viewport.attr('class');
      this.attr.cols = Math.floor(this.attr.width / this.attr.colWidth);
      if (typeof bodyClasses !== 'undefined') {
        bodyClasses = bodyClasses.split(' ');
        bodyClasses = bodyClasses.map(function(i){
          return (i.indexOf('gt') === 0) ? i : "";
        });
        $viewport.removeClass(bodyClasses.join(' '));
      }
      for (var i = 1; i <= this.attr.cols; i++) {
        $viewport.addClass('gt' + i * this.attr.colWidth);
      }
    };


    /**
     * Finds the current breakpoint, attaches a class to the body,
     * and triggers change event when necessary.
     */
    this.setViewportBreakpoint = function() {
      var self = this;
      var breakpoint;

      $.each(this.attr.breakpoints, function(key, val){
        if (self.attr.width < key) {
          breakpoint = val;
          return false;
        }
      });

      if (this.attr.currentBreakpoint !== breakpoint) {
        var previousBreakpoint = this.attr.currentBreakpoint,
            payload;

        this.attr.currentBreakpoint = breakpoint;
        $viewport.removeClass('viewport-' + previousBreakpoint);
        $viewport.addClass('viewport-' + breakpoint);

        payload = {
          'new': this.attr.currentBreakpoint,
          'old': previousBreakpoint
        };

        this.trigger('uiViewportBreakpointChange', payload);
      }

    };




    this.initViewport = function() {
      var $html = $('html');

      /** Add convenience classes to HTML element */
      $html.addClass(App.user.device.deviceOS.toLowerCase());

      this.update();
    };




    this.after('initialize', function() {

      var self = this;

      this.initViewport();

      /** Updates the viewport dimension on resize (debounced) */
      $(window).smartresize(function(ev){
        self.update();
      }, 500);

    });

  }

  return defineComponent(uiViewport);

});
